module.exports = __webpack_public_path__ + "5b1bb4908023b9b81f7e5d4e2649e98f.png";